export default "__VITE_ASSET__3f1c26b6__"